"use strict";
// https://github.com/react-component/util/blob/master/src/raf.ts
Object.defineProperty(exports, "__esModule", { value: true });
var raf = function (callback) { return +setTimeout(callback, 16); };
var caf = function (num) { return clearTimeout(num); };
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    raf = function (callback) { return window.requestAnimationFrame(callback); };
    caf = function (handle) { return window.cancelAnimationFrame(handle); };
}
function wrapperRaf(callback) {
    return raf(callback);
}
exports.default = wrapperRaf;
wrapperRaf.cancel = caf;
//# sourceMappingURL=raf.js.map